(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Routing"), require("i18next"));
	else if(typeof define === 'function' && define.amd)
		define(["Routing", "i18next"], factory);
	else if(typeof exports === 'object')
		exports["authorizationForm"] = factory(require("Routing"), require("i18next"));
	else
		root["jQuery"] = root["jQuery"] || {}, root["jQuery"]["fn"] = root["jQuery"]["fn"] || {}, root["jQuery"]["fn"]["authorizationForm"] = factory(root["Routing"], root["i18next"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 